var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWWerifyGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 259.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00e7ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.52,252.56h0a24.88,24.88,0,0,1-35.15,0L7.28,172.65a24.76,24.76,0,0,1,0-35.08h0a24.9,24.9,0,0,1,35.15,0l80.09,79.92A24.75,24.75,0,0,1,122.52,252.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.92,180l-37.53,37.46L82.6,148.83c-7.94-7.92-6.66-22,2.85-31.53l3.08-3.08c9.51-9.49,23.66-10.77,31.6-2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.4,251.38,148,214.09,355.88,6.74c9.53-9.51,25.63-8.88,35.95,1.42h0c10.31,10.3,10.95,26.36,1.42,35.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.58,147.56l-34.36-34.29a1.25,1.25,0,0,1-.05-1.78l58-57.83c10.38-10.36,27.64-9.93,38.54,1h0c9.09,9.07,9.44,23.41.79,32l-61.09,61A1.27,1.27,0,0,1,184.58,147.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWWerifyGreen);
export default __webpack_public_path__ + "static/media/w_werify_green.df9f139b43e25ab8b4759cb088ad32c5.svg";
export { ForwardRef as ReactComponent };